export default __webpack_public_path__ + "static/media/balloons.e5399c13.png";